<template>
    <div class="apprentice-simple-card">
        <design-2021-apprentice-data-table
            class="periods"
            :items="tableData"
            :fields="periodFields"
            :show-empty="true">
            <template v-slot:options>
                <b-button
                    class="btn-add btn-add-period"
                    v-b-modal="'create-period'"
                    type="button"
                    variant="primary"
                    :label="$t('periods.add_period')">
                    {{ $t('modules.add_period') }}
                </b-button>
            </template>

            <template #cell(period)="row">
                <div class="time_period">
                    {{ row.item.period.start_date | date_written }} tot {{ row.item.period.end_date | date_written }}
                    <!--                    {{formatDate(row.item.period.start_date) + ' tot ' + formatDate(row.item.period.end_date)}}-->
                </div>
            </template>

            <template v-slot:cell(time_start)="data">
                {{ formatTime(data.item.time_start) }}
            </template>

            <template v-slot:cell(time_end)="data">
                {{ formatTime(data.item.time_end) }}
            </template>

            <template v-slot:cell(action)="data">
                <div class="management-actions">
                    <b-button
                        class="btn-edit btn-edit-period"
                        v-b-tooltip.hover
                        variant="primary-icon-only"
                        :title="$t('common.edit')"
                        @click="editPeriod(data.item.id)">
                    </b-button>

                    <b-button
                        class="btn-open btn-open-student-subscriptions"
                        v-b-tooltip.hover
                        variant="primary-icon-only"
                        :title="$t('common.open')"
                        @click="openPeriod(data.item.id)">
                    </b-button>

                    <b-button
                        class="btn-remove btn-remove-period"
                        v-b-tooltip.hover
                        variant="danger-icon-only"
                        :title="$t('common.delete')"
                        @click="removePeriod(data.item.id)">
                    </b-button>
                </div>
            </template>

            <template #empty="scope">
                <div class="not-found with-header attachments-list">
                    <div class="icon">
                        <i class="fas fa-exclamation-circle"></i>
                    </div>
                    <div class="alert-notice">{{ $t('modules.no_periods_found') }}</div>
                </div>
            </template>
        </design-2021-apprentice-data-table>

        <design-2021-module-period-create-modal-component
            :periods-in="periodsIn"
            ref="createModulePeriod"
            @add-module-period="addModulePeriod($event)">
        </design-2021-module-period-create-modal-component>

        <design-2021-module-period-edit-modal-component
            :periods-in="periodsIn"
            ref="editModulePeriod"
            @update-module-period="updateModulePeriod($event)">
        </design-2021-module-period-edit-modal-component>
    </div>
</template>

<script>
export default {
    name: 'design-2021-module-period-index-component',
    props: ['periodsIn', 'modulePeriodsIn'],
    data() {
        return {
            currentModulePeriods: this.modulePeriodsIn,
            periodFields: [
                {
                    key: 'name',
                    label: this.$t('common.name'),
                },
                {
                    key: 'period',
                    label: this.$t('modules.period'),
                },
                {
                    key: 'weekday',
                    label: this.$t('modules.day'),
                },
                {
                    key: 'time_start',
                    label: this.$t('modules.start_time'),
                },
                {
                    key: 'time_end',
                    label: this.$t('modules.end_time'),
                },
                {
                    key: 'duration',
                    label: this.$t('modules.hours'),
                },
                {
                    key: 'action',
                    label: this.$t('common.actions'),
                },
            ],
        };
    },
    computed: {
        tableData() {
            return this.currentModulePeriods.map((modulePeriod) => {
                modulePeriod.period = modulePeriod.period;
                return modulePeriod;
            });
        },
    },
    methods: {
        openPeriod(periodId) {
            window.location.href = this.routes.modulePeriodIndex(periodId);
        },

        editPeriod(periodId) {
            const modulePeriod = this.currentModulePeriods.find((period) => period.id === periodId);
            this.$refs['editModulePeriod'].show(modulePeriod);
        },
        addModulePeriod(modulePeriod) {
            this.currentModulePeriods.push(modulePeriod);
        },
        updateModulePeriod(modulePeriod0) {
            this.currentModulePeriods = this.currentModulePeriods.map((modulePeriod1) => {
                if (modulePeriod1.id === modulePeriod0.id) {
                    return modulePeriod0;
                } else {
                    return modulePeriod1;
                }
            });
        },
        removePeriod(modulePeriodId) {
            this.alert
                .confirm(
                    this.$t('modules.delete_period'),
                    this.$t('modules.are_you_sure_you_want_to_delete_this_period'),
                )
                .then((confirm) => {
                    if (!confirm) {
                        return;
                    }
                    this.axios.delete(this.routes.modulePeriodsUpdate(modulePeriodId)).then(
                        (response) => {
                            this.currentModulePeriods = this.currentModulePeriods.filter(
                                (modulePeriod) => modulePeriod.id !== modulePeriodId,
                            );
                            this.alert.success();
                        },
                        (error) => {
                            this.alert.ajaxError(error);
                        },
                    );
                });
        },

        showPeriod(periodId) {
            window.location.href = this.routes.managementModulesPeriod(periodId);
        },

        formatTime(inputTime) {
            if (!inputTime) {
                return null;
            }

            const timeParts = inputTime.split(':');
            const hour = timeParts[0];
            const minute = timeParts[1];
            return `${hour}:${minute}`;
        },

        formatDate(inputDate) {
            if (!inputDate) {
                return null;
            }

            const dateParts = inputDate.split(' ')[0].split('-');
            const year = dateParts[0];
            const month = dateParts[1];
            const day = dateParts[2];
            return `${day}-${month}-${year}`;
        },
    },
};
</script>

<style scoped lang="scss"></style>
